<template>
  <div>
    <div>
      <v-card>
        <v-card-text v-if="loading">
          <v-card style="margin-top:6%" :height="wHeight-250" class="text-center">
              <v-progress-circular
                :size="wHeight-450"
                width="35"
                color="info"
                indeterminate
              ></v-progress-circular>
          </v-card>                
        </v-card-text>
      </v-card>
      <div class="mt-4 mx-2" v-if="bookings">
				<v-row>
					<v-col class="d-flex justify-space-around" cols="12" >  
            <div  class="text-h5 ml-4">
              Agenda
            </div>
            <v-spacer></v-spacer> 
            <!--        
            <div class="mr-5">
              <template v-if="settings.level>40">
                <v-btn-toggle v-model="mealId" active-class="info">
                  <v-btn 
                    v-for="(m,m2) in meals" :key="m2"
                    v-bind="attrs" v-on="on"
                    :x-large="$vuetify.breakpoint.lg"
                    :small="$vuetify.breakpoint.xs"
                    :class="$vuetify.breakpoint.mdAndDown?'px-2 neu-glow':'px-6 neu-glow'"
                    :value="m.mealId"            
                  >
                    <v-badge
                      v-if="bookings&&bookings.filter(b=>b.active&&b.waiting&&b.mealId==m.mealId).reduce((a,c) => a + c.covers,0)"
                      :content="bookings.filter(b=>b.active&&b.waiting).reduce((a,c) => a + c.covers,0)"
                      color="info"
                      top
                      left
                    >
                    </v-badge> 

                    <v-badge
                      v-if="bookings&&bookings.filter(b=>b.active&&!b.confirmed&&!b.waiting&&b.mealId==m.mealId).reduce((a,c) => a + c.covers,0)"
                      :content="bookings.filter(b=>b.active&&!b.confirmed&&!b.waiting&&b.mealId==m.mealId).reduce((a,c) => a + c.covers,0)"
                      color="black"
                      bottom
                    > 
                    </v-badge>
                    {{m.name}}
                  </v-btn>
                </v-btn-toggle>
              </template>
            </div>
            -->
            <!--
            <div>
              <template v-if="settings.level>40">
                <v-btn-toggle v-model="locationId" active-class="info">
                  <v-btn 
                    v-for="(l,l2) in locations" :key="l2"
                    v-bind="attrs" v-on="on"
                    :x-large="$vuetify.breakpoint.lg"
                    :small="$vuetify.breakpoint.xs"
                    :class="$vuetify.breakpoint.mdAndDown?'px-2 neu-glow':'px-6 neu-glow'"
                    :value="l.locationId"            
                  >
                    {{l.name}}

                  </v-btn>
                </v-btn-toggle>
              </template>
            </div> 
            --> 
              <v-btn-toggle
                v-model="bStatus"
                mandatory
                class="background"
              >
                <v-badge
                  color="success"
                  :content="bookings.filter(b=>b.bStatus=='confirmed').length"
                  overlap 
                  offset-x="24"
                  offset-y="12"    
                  :value="bookings.filter(b=>b.bStatus=='confirmed').length>0"
                >
                  <v-tooltip top >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab
                        class="neu-glow mx-3"
                        active-class="neu-glow-inset"
                        v-bind="attrs" 
                        v-on="on"
                        value="confirmed"
                        style="width:56px;height:56px"
                        >
                        <v-icon large color="success">mdi-clipboard-list</v-icon>
                      </v-btn>
                    </template>
                    <span>Confermati</span>
                  </v-tooltip>
                </v-badge>
                <v-badge
                  color="warning"
                  :content="bookings.filter(b=>b.bStatus=='unconfirmed').length"
                  overlap 
                  offset-x="24"
                  offset-y="12"    
                  :value="bookings.filter(b=>b.bStatus=='unconfirmed').length>0"
                >
                  <v-tooltip top >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab
                        class="neu-glow mx-3"
                        active-class="neu-glow-inset"
                        v-bind="attrs" 
                        v-on="on"
                        value="unconfirmed"
                        style="width:56px;height:56px"
                        >
                        <v-icon large color="warning">mdi-clipboard-list</v-icon>
                      </v-btn>
                    </template>
                    <span>Non Confermati</span>
                  </v-tooltip>
                </v-badge>
                <v-badge
                  color="error"
                  :content="bookings.filter(b=>b.bStatus=='cancelled').length"
                  overlap 
                  offset-x="24"
                  offset-y="12"    
                  :value="bookings.filter(b=>b.bStatus=='cancelled').length>0"
                >
                  <v-tooltip top >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab
                        class="neu-glow mx-3"
                        active-class="neu-glow-inset"
                        v-bind="attrs" 
                        v-on="on"
                        value="cancelled"
                        style="width:56px;height:56px"
                        >
                        <v-icon large color="error">mdi-clipboard-list</v-icon>
                      </v-btn>
                    </template>
                    <span>Cancellati</span>
                  </v-tooltip>
                </v-badge>                
              </v-btn-toggle>               
              <v-spacer></v-spacer> 
              <v-text-field
                v-if="settings.level>=50&&(!showiManagerMap)"
                v-model="search"
                append-icon="mdi-magnify"
                label="Cerca:"
                color="info"
                single-line
                clearable
                hint="Inserire Nome o Cognome o Cellulare"
                persistent-hint="1"
                class="float-right mt-n3"
                @input.native="save"
                :style="$vuetify.breakpoint.mdAndDown?'max-width:100px':'max-width:300px'"
              ></v-text-field>
              <v-spacer></v-spacer>

						<v-btn @click="search=null;timeframe_dialog=true" :fab="date?0:1" class="neu-glow text-h6 float-left mr-6" style="text-align:center;" active-class="neu-glow-inset" >
              <template v-if="date">
							{{dateString}}
              </template>
              <template v-else>
                <v-icon 
                  large
                  color="info"
                  class="mx-3"
                  >
                    mdi-calendar
                </v-icon>                
              </template>
						</v-btn>

              <v-tooltip top v-if="settings.level>50">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="getData(0)"  v-bind="attrs" fab class="neu-glow float-left mr-5" active-class="neu-glow-inset" v-on="on" :loading="loading">
                    <v-icon 
                      large
                      color="info"
                      class="mx-3"
                      active-class="neu-glow-inset"
                      >
                        mdi-sync-circle
                    </v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>            
          </v-col>


				</v-row>
				<v-row dense class="mx-1">
					<v-col cols="12" sm="12">
						<v-card>
              <!--
              <v-card-text v-if="loading||!bookings">
                <v-card style="margin-top:6%" :height="wHeight-250" class="text-center">
                    <v-progress-circular
                      :size="wHeight-450"
                      width="35"
                      color="info"
                      indeterminate
                    ></v-progress-circular>
                </v-card>                
              </v-card-text>
							<v-card-text v-else>
                -->
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-alert
                      class="float-left mb-0"
                      v-if="expired.validForDays<4"
                      :max-width="750"
                      text
                      dense
                      transition="scale-transition"
                      type="error"
                    >
                      <v-row
                        align="center"
                        no-gutters
                      >
                        <v-col v-if="expired.expired" class="grow font-weight-bold">
                          Modulo Scaduto il {{expired.expiry}}: Vai al carrello per riattivarlo
                        </v-col>
                        <v-col v-else class="font-weight-bold">
                          Questo Modulo scade il {{expired.expiry}}: Vai al carrello per Estenderne la durata
                        </v-col>
                        <v-col class="shrink font-weight-bold pl-8">
                          <v-btn
                            small
                            to='/shop'
                            color="info"                            
                          >
                            Estendi
                          </v-btn>
                        </v-col>
                      </v-row>                    
                    </v-alert>  
                  </v-col>
                </v-row>
                    
								<v-row dense>
									<v-col class="elevation-10"  cols="12">
                    <!--:items="!bookings?[]:bookings.filter(b=>b.mealId==mealId&&!waitingListShown&&!b.hideWaitingList||(b.mealId==mealId&&!b.active&&waitingListShown))"-->
										<v-data-table
											dense
											fixed-header
											:headers="bStatus!='cancelled'?headers:headersC"
                      :items="!bookings?[]:bookings.filter(b=>b.bStatus==bStatus)"
											hide-default-footer
											:items-per-page=500
											:height="wHeight-250"
											:item-class="itemClass"
											:loading="loading"
											no-data-text="Nessun dato presente in archivio"
											no-results-text="Nessun Risultato estratto"
											loading-text="Consultazione archivio: attendi..."
										>
											
                      <template v-slot:[`item.visits`]="{ item }">
                        <div style="width:20px;height:90%" :class="item.bStatus=='cancelled'?'error float-left mr-2':item.bStatus=='confirmed'?'success mr-2 float-left':'warning mr-2 float-left'">

                        </div>
												<v-tooltip top>
													<template v-slot:activator="{ on, attrs }">
                            <v-icon class="mt-1" v-bind="attrs" v-on="on">{{item.icon}}</v-icon>
													</template>
													<span>{{item.bookingChannel}}</span>
												</v-tooltip>
                        <template v-if="item.rating">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" :color="item.rating?item.ratingIconColor:'info'">{{item.rating?item.ratingIcon:'mdi-account-question'}}</v-icon>
                            </template>
                            <span>{{item.ratingName}}</span>
                          </v-tooltip>
                        </template>
                        <v-tooltip top>
													<template v-slot:activator="{ on, attrs }">
                            <div  v-bind="attrs" v-on="on" class="ml-2">
                              {{item.visits}}
                            </div>
                          </template>
													<span>Visite</span>
												</v-tooltip>
											</template>
                      

											<template v-slot:[`item.lastName`]="{ item }">
                        <v-btn @click="openWaitingList(item)" :color="item.visits>1?'info':''" text class="ml-1 px-0 font-weight-black text-uppercase">{{item.firstName?item.lastName+' '+item.firstName:item.lastName?item.lastName:item.fullName}}</v-btn>
											</template>

											<template v-slot:[`item.covers`]="{ item }">
												<div 
                          class="text-subtitle-1 font-weight-black" 
                          v-html="item.children?item.covers+' + '+item.children+'':item.covers"
                        >
												</div>										
											</template>

											<template v-slot:[`item.date`]="{ item }">
												<div 
                          class="text-subtitle-1 font-weight-black" 
                          v-html="new Date(item.date).toLocaleDateString('it-IT', { weekday: 'long',month: 'numeric', day: 'numeric', year:'numeric' })"
                        >
												</div>										
											</template>
											<template v-slot:[`item.time`]="{ item }">
												<div 
                          class="text-subtitle-1 font-weight-black" 
                          v-html="item.time"
                        >
												</div>
											</template>
											<template v-slot:[`item.createdDate`]="{ item }">
												<div 
                          class="text-subtitle-1 font-weight-black" 
                          v-html="new Date(item.createdDate).toLocaleDateString('it-IT', {year: '2-digit',  month: '2-digit',  day: 'numeric',  hour:'2-digit',  minute: '2-digit'})"
                        >
												</div>										
											</template>
											<template v-slot:[`item.confirmedTime`]="{ item }">
												<div 
                          v-if="item.confirmedTime"
                          class="text-subtitle-1 font-weight-black" 
                          v-html="new Date(item.confirmedTime).toLocaleDateString('it-IT', { year: '2-digit',  month: '2-digit',  day: 'numeric',  hour:'2-digit',  minute: '2-digit' })"
                        >
												</div>
												<div 
                          v-else
                          class="text-subtitle-1 font-weight-black" 
                          v-html="'N/D'"
                        >
												</div>                        										
											</template>  
											<template v-slot:[`item.cancelled`]="{ item }">
												<div 
                          v-if="item.cancelled"
                          class="text-subtitle-1 font-weight-black" 
                          v-html="new Date(item.cancelled).toLocaleDateString('it-IT', { year: '2-digit',  month: '2-digit',  day: 'numeric',  hour:'2-digit',  minute: '2-digit' })"
                        >
												</div>
												<div 
                          v-else
                          class="text-subtitle-1 font-weight-black" 
                          v-html="'N/D'"
                        >
												</div>                        										
											</template>                           


											<template v-slot:[`item.waitingListTime`]="{ item }">
												<div
                          v-if="item.waitingListTime"
                          class="text-subtitle-1 font-weight-black"
                          :class="(item.hoursRemaining-item.waitingListTime)>0?'success--text':'error--text'"
                          v-html="(item.hoursRemaining-item.waitingListTime)+' Ore'"
                        >
												</div>
											</template>




                      <template v-slot:[`item.waiting`]="{ item }">
												<v-tooltip top v-if="!item.validated">
													<template v-slot:activator="{ on, attrs }">
                            <v-btn :disabled="!item.active" @click="openWaitingList(item)" icon v-bind="attrs" v-on="on" class="pr-2">
                              <v-icon v-bind="attrs" v-on="on" color="blue-grey">mdi-check-outline</v-icon>
                            </v-btn>
													</template>
													<span>Cliente nuovo: non ha confermato su WA<br />Verificare sia Reale</span>
												</v-tooltip>
												<v-tooltip top v-if="item.denied">
													<template v-slot:activator="{ on, attrs }">
                            <v-btn :disabled="!item.active" @click="openWaitingList(item)" icon v-bind="attrs" v-on="on" class="pr-2">
                              <v-icon v-bind="attrs" v-on="on" color="error">mdi-cancel</v-icon>
                            </v-btn>
													</template>
													<span>Prenotazione Rifiutata</span>
												</v-tooltip>
												<v-tooltip top v-else-if="item.waiting">
													<template v-slot:activator="{ on, attrs }">
                            <v-btn :disabled="!item.active" @click="openWaitingList(item)" icon v-bind="attrs" v-on="on" class="pr-2">
                              <v-icon v-bind="attrs" v-on="on" :color="item.hoursRemaining-item.waitingListTime>0?'success':'error'">mdi-clipboard-list</v-icon>
                            </v-btn>                          
													</template>
													<span>{{item.hoursRemaining-item.waitingListTime>0?'Lista: '+(item.hoursRemaining-item.waitingListTime)+' h':'Lista Scaduta'}}</span>
												</v-tooltip>  
												<v-tooltip top v-else-if="!item.confirmed">
													<template v-slot:activator="{ on, attrs }">
                            <v-btn :disabled="!item.active" @click="openWaitingList(item)" icon v-bind="attrs" v-on="on" class="pr-2">
                              <v-icon v-bind="attrs" v-on="on" color="blue-grey">mdi-circle-outline</v-icon>
                            </v-btn>                          
													</template>
													<span>Da Confermare</span>
												</v-tooltip>                                               
                      </template>

                      <template v-slot:[`item.ncr`]="{ item }">
                        <template v-if="!item.waiting&&item.ncr">
                          <v-tooltip top :disabled="!item.ncr">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" :color="settings.options.color">mdi-format-list-bulleted</v-icon>
                            </template>
                            <span>
                            <ul>
                              <li v-for="(r,ri) in item.ncr" :key="ri">
                                {{r.description}}
                              </li>
                            </ul>
                            </span>
                          </v-tooltip> 
                        </template>
                      </template>    

                      <template v-slot:[`item.remarks`]="{ item }">
												<v-tooltip top v-if="item.remarks">
													<template v-slot:activator="{ on, attrs }">
														<v-icon color="orange" v-bind="attrs" v-on="on" small>mdi-chat-processing</v-icon>
													</template>
													<span>{{item.remarks}}</span>
												</v-tooltip>
                      </template>                  
												
											
                      <template v-slot:[`item.requests`]="{ item }">
                        <!--
                        <template  v-if="item.cancelled">
                          <div class="d-flex text-center">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon  v-bind="attrs" v-on="on">mdi-delete-clock</v-icon>
                              </template>
                              <span v-html="item.cancelledByName+': '+new Date(item.cancelled).toLocaleDateString('it-IT', { month: 'numeric', day: 'numeric' })+' '+new Date(item.cancelled).toLocaleTimeString('it-IT')"></span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <a :href="'tel:'+item.phone" :disabled="!item.phone" style="text-decoration:none;" class="pt-2 pl-2">
                                  <v-icon class="success--text" v-bind="attrs" v-on="on">mdi-phone</v-icon>
                                </a>                                
                              </template>
                               <span>Chiama</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon small @click="changeStatus(item,'hideCancelled')" color="warning" class="pl-2" v-bind="attrs" v-on="on">{{item.hideCancelled?'mdi-eye':'mdi-eye-off'}}</v-icon>
                              </template>
                              <span v-html="item.hideCancelled?'Mostra':'Nascondi'"></span>
                            </v-tooltip>                               
                          </div>
                        </template>
                        -->


                        <template v-if="requests">
                          <template v-for="(o, i) in requests.filter(r => item.requests.some(k=>k===r.requestId))">
                            <v-tooltip top  :key="i">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon small class="float-left" color="info" v-bind="attrs" v-on="on">{{o.icon}}</v-icon>
                              </template>
                              <span>{{o.name}}</span>
                            </v-tooltip>
                          </template>
                        </template>

                      </template>

                      <template v-slot:[`item.WAStatus`]="{ item }">
                        <v-tooltip top v-if="item.WAStatus">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon :color="item.WAColor" v-bind="attrs" v-on="on" small>{{item.WAIcon}}</v-icon>
                          </template>
                          <span>{{$t(page+'.'+item.WAStatus)}}</span>
                        </v-tooltip>
                      </template>


                      <template v-slot:[`item.phone`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <a :href="'tel:'+item.fullPhone" :disabled="!item.phone" style="text-decoration:none;" class="pt-2 pl-2">
                              <v-icon @click="markCalled(item)" class="success--text" v-bind="attrs" v-on="on">mdi-phone</v-icon>
                            </a>                                
                          </template>
                            <span>Chiama</span>
                        </v-tooltip>                          
                      </template>

                      <template v-slot:[`item.actions`]="{ item }">
                        <template v-if="!item.confirmed">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn :disabled="!item.active" @click="openWaitingList(item)" icon v-bind="attrs" v-on="on" class="pr-2">
                                <v-icon v-bind="attrs" v-on="on" :color="item.hoursRemaining-item.waitingListTime>0?'success':'error'">mdi-book-edit</v-icon>
                              </v-btn>                             
                            </template>
                            <span>Modifica Prenotazione</span>
                          </v-tooltip>
                        </template>
											</template>
										</v-data-table>
									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
        
      </div>
    </div>
    <v-snackbar v-model="snackbar_confirm_cancellation"
      centered
      dark
      timeout="1500"
      color="red"
    >
      Confermi Cancellazione Prenotazione
      <template v-slot:action="{ attrs }">
        <v-btn
          color="indigo"
          v-bind="attrs"
          @click="snackbar_confirm_cancellation = false"
        >
          Conferma
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbar" 
      absolute centered :color="snackbar_color" :timeout="1500"
    >
      <div class="text-h5 text-center">{{snackbar_message}}</div>
    </v-snackbar>
    <v-dialog v-model="dialog_confirmWABooking" 
      max-width="90%"
      transition="dialog-bottom-transition"
      v-if="confirmBookingDetails"
      class="neu-glow"
      >
      <v-card class="d-flex neu-glow" style="flex-direction:column;">
        <v-card-title class="text-h5">
          Dettagli Cliente/Prenotazione
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_confirmWABooking=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>            
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="3" class="mt-6">
              <v-card class="neu-glow  pb-4">
                <v-row class="py-0 px-3">
                  <v-col cols="12">
                    <v-card class="neu-glow">
                      <v-card-title>
                        Dettagli Cliente
                      </v-card-title>
                      <v-card-text>
                        <div>
                          <v-row v-for="(value,name,di) in bookingDetails[0]" :key="di"> 
                            <v-col cols="6" class="pa-2">
                              <div class="blue-grey darken-3 pl-4 py-1 font-weight-black">{{name}}</div>
                            </v-col>
                            <v-col class="pa-2">
                              <div class="pl-4 py-1 font-weight-black text-right">{{confirmBookingDetails[value]}}</div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-card class="neu-glow mt-3">
                      <v-card-title>
                        Riepilogo Prenotazioni
                      </v-card-title>
                      <v-card-text>
                        <div>
                          <v-row v-for="(value,name,di) in confirmBookingDetails.summary" :key="di"> 
                            <v-col cols="6" class="pa-2">
                              <div class="blue-grey darken-3 pl-4 py-1 font-weight-black">{{name}}</div>
                            </v-col>
                            <v-col class="pa-2">
                              <div class="pl-4 py-1 font-weight-black text-right">{{value}}</div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-card class="neu-glow mt-3">
                      <v-card-title>
                        Canali Prenotazione
                      </v-card-title>
                      <v-card-text>
                        <div>
                          <v-row v-for="(value,name,di) in confirmBookingDetails.bookingChannels" :key="di"> 
                            <v-col cols="6" class="pa-2">
                              <div class="blue-grey darken-3 pl-4 py-1 font-weight-black">
                                <v-icon class="mr-2"  color="info">{{value.icon}}</v-icon>
                                  {{value.bookingChannel}}
                              </div>
                            </v-col>
                            <v-col class="pa-2">
                              <div class="pl-4 py-1 font-weight-black text-right">
                                {{value.cnt}}
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>                                        
                  </v-col>
                </v-row>
              </v-card>           
            </v-col>
            <v-col cols="12" md="9" class="mt-3">
              <v-card class="neu-glow pb-4 my-3">
                <v-row class="py-0 px-3">
                  <v-col cols="12" md="5">
                    <v-card class="neu-glow">
                      <v-card-title>
                        Dettagli Prenotazione
                      </v-card-title>
                      <v-card-text>
                        <div>
                          <v-row v-for="(value,name,di) in bookingDetails[1]" :key="di"> 
                            <v-col cols="6" class="pa-2">
                              <div class="blue-grey darken-3 pl-4 py-1 font-weight-black">{{name}}</div>
                            </v-col>
                            <v-col class="pa-2">
                              <div class="pl-4 py-1 font-weight-black text-right">{{confirmBookingDetails[value]}}</div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-card class="neu-glow">
                      <v-card-title>
                        Dettagli Richiesta
                      </v-card-title>
                      <v-card-text>
                        <v-row v-for="(value,name,di) in bookingDetails[2]" :key="di">
                          <v-col cols="6" class="pa-2">
                            <div class="blue-grey darken-3 pl-4 py-1 font-weight-black">{{name}}</div>
                          </v-col>
                          <v-col class="pa-2">
                            <div class="pl-4 py-1 font-weight-black text-right">{{confirmBookingDetails[value]}}</div>
                          </v-col>
                        </v-row>                        
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-card class="neu-glow ">
                      <v-card-title>
                        Conferma                        
                      </v-card-title>
                      <v-card-text class="text-center pb-6">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" :loading="loading_checkUser" @click="dialog_confirmConfirm=true;">
                              <v-icon color="success">mdi-thumb-up</v-icon>
                            </v-btn>
                          </template>
                          <span>Conferma</span>
                        </v-tooltip> 
                      </v-card-text>
                    </v-card>
                    <v-card class="neu-glow mt-3">
                      <v-card-title>
                        Cancella                      
                      </v-card-title>
                      <v-card-text class="text-center pb-6">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" fab small icon :loading="loading_checkUser" class="neu-glow" @click="confirmWLBooking(0)">
                              <v-icon color="error">mdi-thumb-down</v-icon>
                            </v-btn>
                          </template>
                          <span>Cancella</span>
                        </v-tooltip>   
                      </v-card-text>
                    </v-card>
                  </v-col>                                  
                </v-row>
              </v-card>
              <v-card class="neu-glow  py-4">
                <v-data-table
                  class="mx-4"
                  dense
                  fixed-header
                  :headers="userDetailsHeaders"
                  :items="confirmBookingDetails.history.slice(0,10)"
                  hide-default-footer
                  :items-per-page=500
                  :height="wHeight-700"
                  :loading="loading"
                  no-data-text="Nessun dato presente in archivio"
                  no-results-text="Nessun Risultato estratto"
                  loading-text="Consultazione archivio: attendi..."                
                >
                <template v-slot:[`item.active`]="{ item }">
                  <v-checkbox
                    v-model="item.active"
                    readonly
                    hide-details
                    :color="settings.options.color"
                    class="mt-1"
                  ></v-checkbox>
                </template>

                <template v-slot:[`item.rating`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :color="item.ratingIconColor">{{item.ratingIcon}}</v-icon>
                    </template>
                    <span>{{item.ratingName}}</span>
                  </v-tooltip>                   
                </template>

                <template v-slot:[`item.location`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :color="settings.options.color">{{item.locationIcon}}</v-icon>
                    </template>
                    <span>{{item.locationName}}</span>
                  </v-tooltip>                   
                </template>

                <template v-slot:[`item.delayed`]="{ item }">
                  <div>{{item.delayed>0?item.delayed+' min.':''}}</div>
                </template>

                <template v-slot:[`item.ghost`]="{ item }">
                  <v-checkbox
                    v-model="item.ghost"
                    readonly
                    hide-details
                    :color="settings.options.color"
                    class="mt-1"
                  ></v-checkbox>
                </template>

                </v-data-table>
              </v-card>
            </v-col>            
          </v-row>
        </v-card-text>        
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_confirmConfirm"
      width="460"
    >
    <v-card>
      <v-card-title class="text-h5 mb-2">
        Conferma Prenotazione
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-3" :loading="loading" @click="confirmWLBooking(1)">
                <v-icon color="success">mdi-thumb-up</v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>  
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_confirmConfirm=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>         
      </v-card-title>
      <v-card-text>
        <v-card class="neu-glow pa-5 mb-3">
          <v-alert warning>IMPORTANTE: Verificare la disponibilità di Tavoli e di Combinazioni prima di Confermare</v-alert>
        </v-card>
      </v-card-text>
    </v-card>
    </v-dialog>


   
    <v-dialog v-model="dialog_confirmDelete"
      width="460"
    >
    <v-card>
      <v-card-title class="text-h5 mb-2">
        Elimina Prenotazione
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" :loading="loading" @click="deleteBooking()">
                <v-icon color="error">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Elimina</span>
          </v-tooltip>  
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_confirmDelete=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>         
      </v-card-title>
    </v-card>
    </v-dialog> 
    <!--
    <v-dialog v-model="dialog_freeTableSlots" 
      max-width="1000"
      transition="dialog-bottom-transition"
      v-if="tables&&dialog_freeTableSlots"
      >
      <v-card class="d-flex" style="flex-direction:column;">
        <v-card-title class="text-h5">
          <div class="float-left mr-5">Tavoli liberi a...</div>
          <v-spacer></v-spacer>
					<v-col class="d-inline text-center">
            <v-btn-toggle v-model="mealFilter" mandatory active-class="info white--text">
              <v-btn 
                v-for="(m,m2) in meals" :key="m2"
                v-bind="attrs" v-on="on"
                elevation="5"
                height="40"
                class="px-3 black--text"
                :value="m.mealId"    
              >
              {{$t(page+'.'+m.name)}}
              </v-btn>
            </v-btn-toggle>
					</v-col>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mb-2 mr-3" @click="bookWalkIn()">
                <v-icon color="info">mdi-book-account</v-icon>
              </v-btn>
            </template>
            <span>Prenota Walk-In</span>
          </v-tooltip>          
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mb-2" @click="dialog_freeTableSlots=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>            
          <v-row>
            <v-col class="mt-2">
              <v-btn-toggle v-model="activeSlot" :active-class="settings.options.color+' white--text'" class="d-flex flex-wrap justify-center" >  
                    <v-btn 
                      class="px-3"
                      height="40"
                      :value="c.time"
                      v-for="(c,c1) in covers.filter(c=>c.position==activeLocation&&c.mealId==mealFilter)" :key="c1"
                      :loading="loading"
                    >
                    {{c.name}}</v-btn>
              </v-btn-toggle> 
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="max-height:600px;overflow:auto">
          <v-btn-toggle v-model="walkInSelectedTables" multiple active-class="info white--text" class="d-flex flex-wrap justify-center"> 
            <v-row class="mx-6 mt-2 info lighten-3" v-for="(h,hi) in halls.filter(h=>h.locationId==activeLocationId)" :key="hi">
              <template>
                <v-col cols="12" class="pa-0">
                  <div class="grey lighten-1 pl-4 py-1 font-weight-black">{{h.name}}</div>
                </v-col>
                <v-col v-for="(t,ti) in tables.filter(t => t.hallId===h.hallId&&t.name).sort((a,b) => {return a.ordn>b.ordn?1:-1})" :key="ti">
                  <v-btn
                    :value="t.tableId"
                    small
                    style="font-weight:700"
                    :class="table_button_active(t)"
                  >
                    {{t.name}}
                  </v-btn>
                </v-col>
              </template>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </v-btn-toggle> 
        </v-card-text>
      </v-card>
    </v-dialog>
    -->
    <v-dialog v-model="dialog_userDetails2" 
      max-width="90%"
      transition="dialog-bottom-transition"
      v-if="userDetails"
      >
      <v-card class="d-flex" style="flex-direction:column;">
        <v-card-title class="text-h5">
          Dettagli Cliente
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="dialog_userDetails2=false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>            
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="3" class="mt-6">
              <v-card class="neu-glow elevation-8">
                <v-row v-for="(value, name, index) in userDetails.summary" :key="index">
                  <v-col cols="6">
                    <div class="grey lighten-1 pl-4 py-1 font-weight-black">{{name}}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="pl-4 py-1 font-weight-black">{{value}}</div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="9" class="mt-3">
              <v-card class="neu-glow elevation-8 py-4">
                <v-data-table
                  class="mx-4"
                  dense
                  fixed-header
                  :headers="userDetailsHeaders"
                  :items="confirmBookingDetails.history"
                  hide-default-footer
                  :items-per-page=500
                  :height="wHeight-250"
                  :loading="loading"
                  no-data-text="Nessun dato presente in archivio"
                  no-results-text="Nessun Risultato estratto"
                  loading-text="Consultazione archivio: attendi..."                
                >
                <template v-slot:[`item.active`]="{ item }">
                  <v-checkbox
                    v-model="item.active"
                    readonly
                    hide-details
                    :color="settings.options.color"
                    class="mt-1"
                  ></v-checkbox>
                </template>

                <template v-slot:[`item.rating`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :color="item.ratingIconColor">{{item.ratingIcon}}</v-icon>
                    </template>
                    <span>{{item.ratingName}}</span>
                  </v-tooltip>                   
                </template>

                <template v-slot:[`item.location`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :color="settings.options.color">{{item.locationIcon}}</v-icon>
                    </template>
                    <span>{{item.locationName}}</span>
                  </v-tooltip>                   
                </template>                

                <template v-slot:[`item.delayed`]="{ item }">
                  <div>{{item.delayed>0?item.delayed+' min.':''}}</div>
                </template>

                <template v-slot:[`item.ghost`]="{ item }">
                  <v-checkbox
                    v-model="item.ghost"
                    readonly
                    hide-details
                    :color="settings.options.color"
                    class="mt-1"
                  ></v-checkbox>
                </template>
                </v-data-table>
              </v-card>
            </v-col>            
          </v-row>
        </v-card-text>        
      </v-card>
    </v-dialog>    
  
    <v-dialog v-model="dialog_connectionError"
      width="700"
    >
      <v-card class="">
        <v-card-title class="text-h5 mb-1 font-weight-bold error--text">
          {{errorTitle?'Errore Server':'Errore Connessione'}}
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :href="'https://wa.me/'+settings.options.phoneTechnician">
                <v-icon color="success">mdi-whatsapp</v-icon>
              </v-btn>
            </template>
            <span>Contatta Assistenza</span>
          </v-tooltip> 
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_connectionError = false">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>                
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-4">
          <div v-if="errorMessage===null" class="text-h6">Connessione assente o server sovraccarico:
            <br />
            Riprova tra qualche secondo.
          </div>
          <template v-else>
            <div  class="text-h5 mb-3" v-html="errorTitle"></div>
            <div  class="text-subtitle-1" v-html="errorMessage"></div>
          </template>
          <div class="text-h6 mt-6">
            Se il problema persiste contattare l'assistenza via Whatsapp
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="timeframe_dialog" max-width="500">
        <v-card class="neu-glow">
          <v-card-title class="text-h5">
            Scegli Intervallo
            <v-spacer></v-spacer>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow mr-4" @click="date=null;timeframe_dialog = false;getData(0)">
                  <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Rimuovi Data</span>
            </v-tooltip> 
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab small icon class="neu-glow" @click="timeframe_dialog = false">
                  <v-icon color="info">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip> 
          </v-card-title>
          <v-card-text>
            <v-date-picker 
              class="mt-4" 
              v-model="date" 
              locale="it-IT"
              color="info"
              full-width
              show-week
              :min="settings.level>=100?null:new Date().toISOString().slice(0, 10)"
              first-day-of-week=1 
              header-color="info"
              @change="getDate(0)"
            >
            </v-date-picker>
          </v-card-text>
        </v-card>
    </v-dialog>


    <v-dialog v-model="dialog_dateWide"
      width="800"
    >
      <v-card>
        <v-date-picker
          :picker-date.sync="pickerDate"
          class="wide_dp text-h5"
          elevation="5"
          header-color="info"
          v-if="events"
          locale="it"
          first-day-of-week=1
          v-model="date"
          full-width
          show-week
          range
          :min="settings.level>=100?null:new Date().toISOString().slice(0, 10)"
          color="info"
          :events="events.map(e => e.date)"
          :event-color="settings.level>=100?events.map(e => e.covers):events.map(e => new Date(e.date).setHours(0,0,0,0) >= new Date().setHours(0,0,0,0)?e.covers:'')"
          style="min-height:580px"
        >     
        <v-spacer></v-spacer>
          <v-btn
            fab
            icon
            class="neu-glow d-flex justify-right"
            color="info"
            @click="dialog_dateWide=false"
          >
            <v-icon color="info">mdi-close</v-icon>
          </v-btn>  
        </v-date-picker>
      </v-card>
    </v-dialog>     
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import _ from 'lodash'
export default {
  data() {
    return {
      max_bookable_rules:[v =>(v&&v>=1&&v<=this.max_bookable)],
      page: "Booking",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_selectTable:false,
      dialog_disableTable:false,
      dialog_confirmDelete:false,
      dialog_dateWide:false,
      dialog_walkInHelp:false,
      dialog_date:false,
      dialog_edit:false,			  
      dialog_walkIn:false,
      dialog_userRatingHelp:false,
      dialog_accomplished_message:'',
      dialog_resetTables:false,
      dialog_freeTableSlots:false,
      dialog_connectionError:false,
      dialog_panView:false,
      dialog_confirmWABooking:false,
      dialog_DirectBookingLock:false,
      dialog_enterBillAmount:false,
      dialog_waitingListTime:false,
      dialog_confirmConfirm:false,
      snackbar_confirm_cancellation:false,
      snackbar_confirm_cancellation_text:null,
      max_bookable:150,
      overbooking:150,
      timeframe:[],
      timeframe_dialog:false,
      loading_checkUser:false,
      previousDisabledTables:[],
      selectedBooking:null,
      disabledTables:[],
      disabledTablesName:[],
      loading:false,
      loading_edit:false,
      loading_datepicker:false,
      loading_walkIn:false,
      walkInLocations:[],
      pan_view_details:false,
      panTables:null,
      date:null, // for datepicker
      search:null,
      dateString:null,
      time:null,
      area:null,
      activeSlot:null,
      activeLocation:null,
      item:null, // for select table
      halls:null,
      assignedTablesId:[],	   
      ATA:null,
      tablesList:null,
      currentTimePC:null,
      covers:null,
      slot:null,
      slotId:null,
      areaId:null,
      locationId:null,
      shift:null,
      //shiftClassId:null,
      mealId:null,
      meals:null,
      newUser:0,
      optIn:1,
      errorTitle:null,
      errorMessage:null,
      bookings:null,
      bookings_previous:null,
      fullname:null,
      events:null,
      eventscolor:null,
      activeOptions:null,
      tableAlert:false,
      tables:null,
      tablesId:null,
      dialog_free_tables:false,
      free_tables:null,
      origin:null,
      loading_free:false,
      polling:null,
      pickerDate:null,
      countryCode:39,
      phone:null,
      isnull:null,
      helpType:null,
      mealFilter:null,
      tablesByCovers:[],
      errorPhone:'Solo numero di cellulare',
      errorPhone_status:0,
      successPhone_status:0,
      cancelledShown:false,
      waitingListShown:false,
      walkInSelectedTables:[],
      rowToBlink:[],
      oldLocationId:[],
      //fullnames:['Extra'],
      billAmount:null,
      expired:null,
      bookingDetails:[
                {"Nome":"fullName","Telefono":"fullPhone","CAP":"postalCode","Email":"email"},
                {"Data":"bookingDate","Ora":"time","Coperti":"covers","Bambini":"children","Sala":"locationName","Note":"remarks"},
                {"Data Richiesta":"createdDate","Ora Richiesta":"createdTime","In Lista?":"isWaitingList","Ore Lista":"waitingListTime","Scadenza lista":"endOfWaitingList","Ore a Scadenza Lista":"hoursToEndOfWaitingList"}],
      booking:{locationId:null,hallId:null,bookingId:null,countryCode:39,covers:null,children:null,date:null,fullname:null,requests:[],phone:null,slotId:null,time:null,optIn:false,waitingTime:null},
      locations:null,
      selectedBooking_hash:null,
      disabledTables_hash:null,
      headers_free: [
                //{text: 'N', align: 'start', value: 'new'},
                { text: 'Occupato',    value: 'busy_at',     align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                { text: 'Tavolo',       value: 'table',       align: 'center',  sortable: false, class:'pl-3 pr-1 text-lg-button' },
                { text: 'Libero',  value: 'free_at',     align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                //{ text: 'Assegna',      value: 'actions',     align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
              ],
      headers: [
                //{text: 'N', align: 'start', value: 'new'},
                { text: 'Info',       value: 'visits',        align: 'start',   sortable: false, class:'text-h6 font-weight-bold px-1' }, 
                { text: 'Prenotata',  value: 'createdDate',   align: 'center',  sortable: true, class:'text-h6 font-weight-bold px-1' },
                { text: 'Confermata', value: 'confirmedTime', align: 'center',  sortable: true, class:'text-h6 font-weight-bold px-1' },
                { text: 'Nome',       value: 'lastName',      align: 'start',   sortable: true, class:'text-h6 font-weight-bold px-1' }, 
                { text: 'Area',       value: 'location',      align: 'center',  sortable: true, class:'text-h6 font-weight-bold px-1' },  
                { text: 'Px',         value: 'covers',        align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },                        
                { text: 'Data',       value: 'date',          align: 'center',  sortable: true, class:'text-h6 font-weight-bold px-1' },
                { text: 'Ora',        value: 'time',          align: 'center',  sortable: true, class:'text-h6 font-weight-bold px-1' },
                { text: 'Status',     value: 'waiting',       align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },

                //{ text: 'Rimangono',value: 'waitingListTime',   align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                //{ text: 'Motivi',   value: 'ncr',           align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'Note',       value: 'remarks',       align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'R',          value: 'requests',      align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'WA',         value: 'WAStatus',      align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'Chiama',     value: 'phone',         align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'Azione',     value: 'actions',       align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                //{ text: 'Azione',   value: 'actions',       align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1', width: "200" },                
              ],
      headersC: [
                //{text: 'N', align: 'start', value: 'new'},
                { text: 'Info',       value: 'visits',        align: 'start',   sortable: false, class:'text-h6 font-weight-bold px-1' }, 
                { text: 'Prenotata',  value: 'createdDate',   align: 'center',  sortable: true, class:'text-h6 font-weight-bold px-1' },
                { text: 'Cancellata', value: 'cancelled',   align: 'center',  sortable: true, class:'text-h6 font-weight-bold px-1' },
                { text: 'Nome',       value: 'lastName',      align: 'start',   sortable: true, class:'text-h6 font-weight-bold px-1' }, 
                { text: 'Area',       value: 'location',      align: 'center',  sortable: true, class:'text-h6 font-weight-bold px-1' },  
                { text: 'Px',         value: 'covers',        align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },                        
                { text: 'Data',       value: 'date',          align: 'center',  sortable: true, class:'text-h6 font-weight-bold px-1' },
                { text: 'Ora',        value: 'time',          align: 'center',  sortable: true, class:'text-h6 font-weight-bold px-1' },
                { text: 'Status',     value: 'waiting',       align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },

                //{ text: 'Rimangono',value: 'waitingListTime',   align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                //{ text: 'Motivi',   value: 'ncr',           align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'Note',       value: 'remarks',       align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'R',          value: 'requests',      align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'WA',         value: 'WAStatus',      align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'Chiama',     value: 'phone',         align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'Azione',     value: 'actions',       align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                //{ text: 'Azione',   value: 'actions',       align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1', width: "200" },                
              ],              
      userDetailsHeaders: [
                { text: 'Attivo',     value: 'active',        align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'Data',       value: 'date',          align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'Ora',        value: 'time',          align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'Coperti',    value: 'covers',        align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'Ghost',      value: 'ghost',         align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'Scontrino',  value: 'avgBill',       align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'AvgBill',    value: 'dailyAvgBill',  align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'Rating',     value: 'rating',        align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
                { text: 'Posizione',  value: 'location',      align: 'center',  sortable: false, class:'text-h6 font-weight-bold px-1' },
              ],             
      confirmBookingDetails:null,
      slots:  null,
      requests:null,
      shifts: null,
      foodStyles:null,
      confirmedUnconfirmed:[],
      bStatus:null,
     
    };
  },
  computed : {
    ...mapGetters(["settings","SST","countries"]),
    continue_button:function()
    {
      var p2=this.booking.covers===null;
      var p3=(this.booking.slotId);
      var p4=(this.locationId);
      var p5=(this.fullname);
      var p7=p2||p3||p4||p5;
     return p7;
    }
  },
  created(){
    console.log(1357,this.settings)
    //this.getDate(0);
    //this.pollData()
    //console.log(1360,this.timer)
    this.loading=true;
    
    console.log(716,this.user);
    if (this.settings&&this.settings.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData(0)
    }
  },
  mounted() {
      //console.log(768,this.$route.query.user)
      console.log(1935,this.SST)
  },
  watch : {
    pickerDate (newVal,oldVal) {
      console.log(2068,newVal,oldVal)
      this.date=newVal+'-01';
      this.getMonthlyBookings()
    },
    /*
    date (newVal,oldVal) {
      console.log(2071,newVal,oldVal)
    },  
    'booking.waitingTime':function(newVal,oldVal)
    {
      console.log(2119,newVal,oldVal)
      this.$nextTick(() => {
        console.log(2121,newValue,oldValue)
      })
    },*/
    'selectedBooking.locationId': function (newVal,oldVal)
    {
      this.oldLocationId=[newVal,oldVal];
      console.log(2002,this.oldLocationId)
    },
    'booking.date':function(newVal,oldVal)
    {
      console.log(1605,newVal,oldVal)
      if(newVal)
      {
        this.getWalkInData();
      }
    },
    'booking.phone':function(newValue)
    {
      console.log(1618,newValue);
      if(this.countryCode==39)
      {
        if (newValue)
        {
          if(newValue.length>8&&newValue.length!=10)
          {
            this.errorPhone='Solitamente 10 cifre: verifica'
            this.errorPhone_status=0;
            this.successPhone_status=1;
          }
          else if (newValue.length==10)
          {
            this.errorPhone='Numero formalmente Corretto'
            this.successPhone_status=1;
            this.errorPhone_status=0
            this.openWaitingList(newValue);
          }
          else
          {
            this.errorPhone='Solo numero di cellulare';
            this.errorPhone_status=0
            this.successPhone_status=0;      
          }
        }
        else
        {
          this.errorPhone='Solo numero di cellulare';
          this.errorPhone_status=0
          this.successPhone_status=0
        }
      }
    },
    selectedBooking(newValue,oldValue)
    {
      console.log(1359,newValue,oldValue)
      /*
      this.selectedBooking.time=this.covers.find(c=>c.slotId==newValue.slotId).name;
      this.selectedBooking.location=this.locations.find(l=>l.locationId==newValue.locationId).name;
      console.log(1362,this.selectedBooking,this.covers.find(c=>c.slotId==newValue.slotId).name,this.locations.find(l=>l.locationId==newValue.locationId).name);
      */
    },
    activeSlot (newValue,oldValue)
    {
      console.log(1300,newValue,oldValue)
      if (newValue!=oldValue)
      {
        this.ATA=new Date('1970-01-01T' + newValue.substring(0,8) + 'Z').getTime() / 1000;
        console.log(1304, this.ATA);
      }
    },
    date (newValue,oldValue)
    {
      console.log(1452,newValue,oldValue);
      if(oldValue!==null&&this.events)
      {
        this.date=newValue;
        this.getDate(0)
      }
    },
    item (newValue) {
      //console.log(789,newValue)
      //this.getData(newValue)
    },
    assignedTablesId(newValue)
    {
      this.assignTables(newValue);
    },
    disabledTables(newValue,oldValue)
    {
      console.log(1075,newValue,oldValue)
      this.disableTable(newValue)
    }
  },
  methods:
  {
    save: _.debounce(function (event) {
      //this.refreshItem(event.target.name,event.target.value)
      console.log(1384,event,event.target);
      console.log(1385,event.target.name,event.target.value,event.target.id)
      //console.log(298,this.dowId,this.mealId,this.activeSlots)
      //console.log(299,this.VMOptions[event.target.name])
      /*
      var v=event.target.value
      var value=v===false?0:v===true?1:v===''?null:v
      var dow=this.dows.findIndex(d=>d==this.dowId)+1
      var pload={"parameter":event.target.name,"value":value,"slotId":event.target.id,"dow":dow};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"AllParametersByDOW_single","payload":pload};
      console.log(307,payload)*/
      this.date=null;
      this.getData(0)
    }, 800),
    save2(value, field, slotId,event) {
      //@click="save2('manualConfirmation',value,s.slotId)"
      //console.log(311,value, field,slotId,event,event.target.name,event.target.value);

      var pload={"parameter":field,"value":value===false?0:value===true?1:value===''?null:value,"slotId":slotId,"dow":dow};
      //var pload={[field]:value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value};
      //pload[field]=value;
      var action='saveItem';
      let payload={"action":action,"table":"AllParametersByDOW_single","payload":pload};
      console.log(318,payload)
      this.updateDB(payload)
    },        
      change_timeframe(){
      if (this.timeframe[0]>this.timeframe[1])
      {
        let tmp=this.timeframe[0];
        this.timeframe[0]=this.timeframe[1]
        this.timeframe[1]=tmp;
      }
      this.$store.dispatch("set_timeframe", this.timeframe);  
      this.loadData();
    },
      change_date(){
        /*
      if (this.timeframe[0]>this.timeframe[1])
      {
        let tmp=this.timeframe[0];
        this.timeframe[0]=this.timeframe[1]
        this.timeframe[1]=tmp;
      }
      this.$store.dispatch("set_timeframe", this.timeframe);  
      */
      this.getData();
    },    
    async confirmWLBooking(confirmed)
    {
        this.loading_checkUser==true;
        console.log(2877,confirmed,this.booking,this.confirmBookingDetails)
        const WAAction=this.confirmBookingDetails.waiting?(confirmed?'booking_confirmed_from_wl':'booking_denied'):(confirmed?'booking_confirmed':'booking_denied')
        const payload=JSON.stringify({"action":"confirmWaitingListOrManuallyConfirmBooking","payload":{"bookingId": this.confirmBookingDetails.bookingId,"status":confirmed,"WAAction":WAAction}})
        const res = await this.$http.post('/booking/booking.php', payload );
        this.loading_checkUser= false;
        this.dialog_confirmConfirm=false;
        switch (res.data.errorid)
        {
          case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              this.confirmBookingDetails=res.data.payloads;
              console.log(2698,res.data.payloads)
              this.snackbar=true;
              this.snackbar_color='success'
              this.snackbar_message=res.data.message;
              await this.getData();
              //this.dialog_confirmWABooking=false;
              //return true;
          break;
          case '0007':
            var responsePayload=JSON.parse(res.data.payload)
            this.errorTitle=responsePayload.errorInfo[2];
            this.errorMessage=responsePayload.xdebug_message;
            console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
            this.dialog_connectionError=true;
          break;
          case '0006':
              this.$router.push('/auth/login').catch(() => {});
          break;
        }  
    },
    /*changeWaitingTime(v)
    {
      console.log(2266,this.booking,this.booking.waitingTime,v)
      if(this.booking.waitingTime)
      {
        this.booking.waitingTime=this.booking.waitingTime/1+v/1
      }
      else
      {
        this.booking.waitingTime=1;
      }
      console.log(2275,this.booking,this.booking.waitingTime,v)
      this.$nextTick(() => {
        console.log(2121,v,this.booking.waitingTime)
      })
    },*/
    async openWaitingList(item)
    {
      console.log(2685,this.booking.date,item);
      //this.dialog_confirmWABooking=true;
      //this.loading_checkUser=true;
      //try{
          const payload=JSON.stringify({"action":"confirmBookingDetails","payload":{"bookingId": item.bookingId}});
          const res = await this.$http.post('/booking/booking.php', payload );
          this.loading_checkUser= false;
          switch (res.data.errorid)
          {
            case '0':
                sessionStorage.setItem('jwt', res.data.jwt);
                this.confirmBookingDetails=res.data.payloads;
                this.confirmBookingDetails.bookingId=item.bookingId;
                //this.confirmBookingDetails.bookingId=item.bookingId;
                //this.checkedPhone=res.data.payloads.cnt;
                console.log(2698,this.confirmBookingDetails)
                this.dialog_confirmWABooking=true;
                //return true;
            break;
            case '0007':
              var responsePayload=JSON.parse(res.data.payload)
              this.errorTitle=responsePayload.errorInfo[2];
              this.errorMessage=responsePayload.xdebug_message;
              console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
              this.dialog_connectionError=true;
            break;
            case '0006':
                this.$router.push('/auth/login').catch(() => {});
            break;
          }  
      /*} catch(e)
      {
        //this.loading= false;
      }*/
    },       
    async openWaitingList2(item){
      console.log(1009,this.booking.date,item);
      this.loading_checkUser=true;
      try{
          const payload=JSON.stringify({"action":"confirmBookingDetails","payload":{"bookingId": item.bookingId}});
          const res = await this.$http.post('/booking/booking.php', payload );
          this.loading_checkUser= false;
          switch (res.data.errorid)
          {
            case '0':
                sessionStorage.setItem('jwt', res.data.jwt);
                this.booking.fullname=''
                this.confirmBookingDetails=res.data.payloads;
                //this.checkedPhone=res.data.payloads.cnt;
                this.booking.fullname=res.data.payloads.fullname
                console.log(1036,this.checkedPhone,this.booking,this.confirmBookingDetails)
                //return true;
            break;
            case '0007':
              var responsePayload=JSON.parse(res.data.payload)
              this.errorTitle=responsePayload.errorInfo[2];
              this.errorMessage=responsePayload.xdebug_message;
              console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
              this.dialog_connectionError=true;
            break;
            case '0006':
                this.$router.push('/auth/login').catch(() => {});
            break;
          }  
      } catch(e)
      {
        //this.loading= false;
      }
    },     
    bookWalkIn()
    {
      console.log(1862,this.walkInSelectedTables)
      this.dialog_freeTableSlots=false;
      this.booking.date=new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000 )).toISOString().split("T")[0]
      this.dialog_walkIn=true;
    },
    lockDirectBooking()
    {
      this.dialog_confirm_lock=true
    },
    disabledSlot(s,s1)
    {
      //console.log(1667,s,s1,this.booking.covers,this.tablesByCovers)
      var k;
      if(this.booking.covers)
      {
        var covers=this.booking.covers.split('+')[0];
        var requiredTables=this.tablesByCovers.find(t=>t.covers==covers).tables;
        var availableCovers=(s.totCovers-s.usedCovers)/1+this.overbooking/1;
        var zk=this.walkInLocations.find(l => l.locationId==this.booking.locationId).tables[s1].availableTables/1+this.overbooking/1
        k=covers>availableCovers||!this.booking.mealId||requiredTables>zk;
        //var z=this.booking.covers>((s.totCovers-s.usedCovers)/1+this.overbooking/1)||!this.booking.mealId||this.tablesByCovers.find(t=>t.covers==covers).tables>this.locations.find(l => l.locationId==this.booking.locationId).tables[s1].availableTables/1+this.overbooking/1
        console.log(1635,s,k,this.booking,this.locations)
      }
      return k;
    },
    showWaitingList()
    {
      this.waitingListShown=!this.waitingListShown;
    },
    showCancelled()
    {
      this.cancelledShown=!this.cancelledShown;
    },
    allowedDates(a) {
      return val => ![a].includes(new Date(val).getDay());
    },  
    setCovers(c)
    {
      console.log(1497,c,this.booking.covers);
      if(c=='C')
      {
        this.booking.covers='';
      }
      else
      {
        this.booking.covers=this.booking.covers==null?'':this.booking.covers;
        //console.log(1505,c,this.covers);
        this.booking.covers+=c.toString();
        //console.log(1507,c,this.covers);
      }
       this.booking.covers=parseInt(this.booking.covers)>this.max_bookable?this.max_bookable:this.booking.covers;
    },
    locationDescription(l)
    {
      if (!this.booking.slotId)
      {
        return l.name;//location.name
      }
      else
      {
        console.log(1697,l,this.booking.slotId)
        var z=l.tables.find(t=>t.slotId==this.booking.slotId)
        console.log(1716,z);
        return l.name+'<br># ' + (z.availableTables-z.usedTables) +'/'+ z.availableTables;
      }
    },
    openDialogHelp(h)
    {
      this.helpType=h;
      this.dialog_walkInHelp=true;
    },
    openDialogDetails(item)
    {
      this.openWaitingList(item);
      this.dialog_confirmWABooking=true;
    },
    openDialogEdit(item)
    {
      if (this.settings.level>50)
      {
        console.log(1122,item,this.requests);
        this.selectedBooking=JSON.parse(JSON.stringify(item));
        this.selectedBooking.requests=this.requests.map(el => { this.selectedBooking.requests.some(rr=>rr==el.requestId)?el.value=true:el.value=false; return el} )
        /*
        if (this.selectedBooking.requests.length==0)
        {
          this.selectedBooking.requests=[...this.requests]
        }
        else
        {
          this.selectedBooking.requests=this.requests.map(el => { this.selectedBooking.requests.some(rr=>rr==el.requestId)?el.value=true:el.value=false; return el} )
          //this.requests.map(el => {this.selectedBooking.requests.forEach(k=>{k===el.requestId?el.value=1:el.value=0}); return el} )
        }*/
        this.selectedBooking_hash=JSON.stringify(this.selectedBooking);
        console.log(1131,this.selectedBooking,this.selectedBooking.requests)
        this.dialog_edit=true
      }
    },
    async markCalled (item)
    {
        console.log(1846,item)
        let payload={"action":"PBX_Messages_from_WaitingList_Called_set","payload":JSON.stringify(item)};
        console.log(1848,payload)
        const idx=this.bookings.findIndex(m =>m.bookingId==item.bookingId)
        console.log(119,idx)
        let url='/pbx/pbx.php';
        this.messages[idx].called=new Date;
        let w= await this.updateDB(payload,url)
        console.log(122,w);       
        this.snackbar=false;
        if (w.errorid=='0')
        {
            //console.log(126,w.payloads.callId)
            //const idx=this.messages.findIndex(m =>m.callId==w.payloads.callId)
            //console.log(128,idx)
            //this.messages[idx].called=new Date;
            //console.log(130,this.messages)
        }	
    },        
    async updateDB(payload,url='/booking/booking.php'){
        try{
            const res = await this.$http.post(url, payload);
            //console.log(1022,res);
            if (res.data.errorid=='0')
            {
              sessionStorage.setItem('jwt', res.data.jwt);
           }
            else
            {
              console.log(1222);
              //this.$router.push('/auth/login').catch(() => {});
            }
            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
          this.loading= false;
          this.dialog_connectionError=true;
        }
    },/*
    getDifference(array1, array2) {
      return array1.filter(object1 => {
        return !array2.some(object2 => {
          return object1.id === object2.id;
        });
      });
    },*/
    async getWalkInData()
    {
      console.log(2187,this.booking.date);
      this.loading_walkIn=true;
      this.dialog_connectionError=false;
      //try{
          const payload=JSON.stringify({"date": this.booking.date,"action":"walkInLocations_get"});
          const res = await this.$http.post('/manage/manage.php', payload );
          console.log(1811,res, new Date());
          this.loading= false;
          switch (res.data.errorid)
          {
            case '0':
                sessionStorage.setItem('jwt', res.data.jwt);
                this.walkInLocations=res.data.payloads.locations;
                console.log(2061,this.walkInLocations)
                return true;
            break;
            case '0007':
              var responsePayload=JSON.parse(res.data.payload)
              this.errorTitle=responsePayload.errorInfo[2];
              this.errorMessage=responsePayload.xdebug_message;
              console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
              this.dialog_connectionError=true;
            break;
            case '0006':
                this.$router.push('/auth/login').catch(() => {});
            break;
          }  
      /*} catch(e)
      {
        this.loading= false;
        this.dialog_connectionError=true;
      }*/
    },
    async getData(row)
    {
      console.log(1849,row,this.date);
      this.loading=true;
      this.dialog_connectionError=false;
      this.bookings_previous=this.bookings?JSON.parse(JSON.stringify(this.bookings)):null;
      var sproc=this.date?'_date':this.search?'_search':'';
      //try{
          const payload=JSON.stringify({"sproc":sproc,"search":this.search,"date": this.date,"action":"getBookings_db"});
          const res = await this.$http.post('/manage/manage.php', payload );
          console.log(1811,res, new Date());
          this.loading= false;
          switch (res.data.errorid)
          {
            case '0':
                sessionStorage.setItem('jwt', res.data.jwt);
                this.bookings=res.data.payloads.bookings||[];
                console.log(1787,this.bookings.filter(b=>b.bStatus=='confirmed').length,this.bookings.filter(b=>b.bStatus=='unconfirmed').length,this.bookings.filter(b=>b.bStatus=='cancelled').length)
                this.expired=res.data.payloads.expired;
                /*if (this.bookings_previous)
                {
                  this.rowToBlink=this.getDifference(this.bookings, this.bookings_previous)
                  console.log(1999,this.bookings,this.bookings_previous,this.rowToBlink)
                }*/
                this.tables=res.data.payloads.tables;
                this.shifts=res.data.payloads.shifts;
                this.halls=res.data.payloads.halls;
                this.locations=res.data.payloads.locations;
                console.log(2044,this.locations);
                //this.slots=res.data.manage.locations[0].slots;
                //this.covers=res.data.payloads.locations[0].covers;
                this.meals=res.data.payloads.meals;
                this.foodStyles=res.data.payloads.foodStyles?[...res.data.payloads.foodStyles]:null;
                this.requests=res.data.payloads.requests?[...res.data.payloads.requests]:[];
                this.tablesByCovers=res.data.payloads.tablesByCovers;
                this.userRatings=res.data.payloads.userRatings;
                this.booking.requests=this.requests;//[...res.data.manage.requests];
                this.booking.foodStyles=this.foodStyles;
                //this.selectedBooking.requests=this.requests.map(el => { this.selectedBooking.requests.some(rr=>rr==el.requestId)?el.value=1:el.value=0; return el} )
                //this.shift=new Date().getHours()>16?'dinner':'lunch';
                //var mealName=new Date().getHours()>16?'dinner':'lunch';
                //console.log(1998,new Date().getHours(),mealName,this.meals)
                //this.mealId=this.meals.find(m => m.meal==mealName).mealId;
                if(res.data.payloads.currentValues&&!this.mealId)
                {
                  //this.mealId=res.data.payloads.currentValues.mealId;
                  this.currentValues=res.data.payloads.currentValues.mealId;
                  console.log(2000,this.mealId)
                }
                //this.settings.username=JSON.parse(localStorage.getItem('settings')).username;
                this.settings.level=parseInt(JSON.parse(sessionStorage.getItem('settings')).level);
                this.settings.avatar=JSON.parse(sessionStorage.getItem('settings')).avatar;
                console.log(1827,this.settings.level,this.shifts,this.settings,this.settings.avatar)
                console.log(2061,this.requests,this.booking.requests)
                console.log(2905,this.bookings)
                return true;
            break;
            case '0007':
              var responsePayload=JSON.parse(res.data.payload)
              this.errorTitle=responsePayload.errorInfo[2];
              this.errorMessage=responsePayload.xdebug_message;
              console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
              this.dialog_connectionError=true;
            break;
            case '0006':
                this.$router.push('/auth/login').catch(() => {});
            break;
          }/*  
      } catch(e)
      {
        this.loading= false;
        this.dialog_connectionError=true;
      }*/
    },/*
    async getMonthlyBookings()
    {
      if ( this.settings.level>50)
      {
        this.events=[];
        this.eventscolor=[];
        this.dialog_dateWide=true;
        this.loading_datepicker=true;
        try{
            const payload=JSON.stringify({"date": this.date,"action":"getMonthlyBookings"});
            const res = await this.$http.post('/manage/manage.php', payload );
            //console.log(834,res);
            this.loading_datepicker=false
            switch (res.data.errorid)
            {
            case '0':
                sessionStorage.setItem('jwt', res.data.jwt);
                this.events=res.data.events?res.data.events:[];
                
            break;
            case '0006':
                this.$router.push('/auth/login').catch(() => {});
            break;
            }
        } catch(e)
        {
            this.loading_datepicker= false;
            this.loading= false;
            this.dialog_connectionError=true;
        }
      }
    },
	 */ 
    DateToFormattedString(d) {                                         
        var yyyy = d.getFullYear().toString();                                    
        var mm = (d.getMonth()+1).toString(); // getMonth() is zero-based         
        var dd  = d.getDate().toString();             
        return yyyy + '-' + (mm[1]?mm:"0"+mm[0]) + '-' + (dd[1]?dd:"0"+dd[0]);
    },    
    getDate(days)
    {
      const dateOptions = { month: 'long', day: 'numeric',weekday: 'long' };
      var result = this.date==null?new Date():new Date(this.date);
      result.setDate(result.getDate() + days)
      //result.setHours(result.getHours())
      this.timeframe_dialog=false
      this.date= this.DateToFormattedString(result);//result.toISOString().split('T')[0];
      this.dateString=result.toLocaleDateString('it-IT', dateOptions);
      //console.log(809,this.date,this.dateString)
      this.loading=true;
      this.getData(1996)
    },
    reset()
    {
        this.booking={locationId:null,hallId:null,bookingId:null,countryCode:39,covers:null,children:null,date:null,fullname:null,requests:[],phone:null,slotId:null,time:null,optIn:false};
        this.booking.requests=[...this.requests];
        console.log(2175,this.booking.requests,this.requests)
        /*this.requests.map(o => {o.value=o.requestId=='chairs'?0:false});
        this.covers=null;       
        this.time=null;
        this.slotId=null;
        this.area=null;
        this.locationId=null;
        this.fullname=null;
        this.phone=null;
        this.remarks=null;*/
       
    },
    calcTables()
    {
      return this.covers<=3?1:(this.covers<=6?2:Math.ceil((this.covers-2)/2))
		},
    itemClass: function (item) {
        var clr;
        if (this.rowToBlink.some(k =>k===item.bookingId))
        { 
          clr = 'blink';
        }
        else if (item)
        {
          clr=item.slid % 3?(item.slid % 2?'blue-grey darken-3':'blue-grey darken-3'):'blue-grey darken-3'
          //console.log(1629,clr)
        }
        return clr;
    },
    async getNewBookings()
    {
      try{
          //const payload=JSON.stringify({"action":"getNewBookingsAlert"});
          const payload=JSON.stringify({"date": this.date,"action":"getBookings"});
          const res = await this.$http.post('/manage/manage.php', payload );
          console.log(2015,'polling',res);
          this.loading_free=false
          switch (res.data.errorid)
          {
          case '0':
              this.newBookings=res.data.newBookings;
              this.dialog_connectionError=false;
              if (this.newBookings)
              {
                this.$store.dispatch("setNewBookingsAlert", this.newBookings.length);
              }
              else
              {
                this.$store.dispatch("setNewBookingsAlert", null);
              }
          break;
          case '0006':
              this.$router.push('/auth/login').catch(() => {});
          break;
          }
      } catch(e)
      {
          this.loading_free= false;
          this.loading= false;
          this.dialog_connectionError=true;
      }      
    },    
    pollData () {
      this.polling = setInterval(() => {
        this.getData()
      }, 300000)
    },
    blink(item) {
      //if (this.rowToBlink.map(r => item.id==r)) return 'blink';
      if (this.rowToBlink.some(k =>k===item.id)) return 'blink';
      //rows.map(r => i.some(k => k===r.id))
      return '';
    }    
  },
  beforeDestroy () {
    clearInterval(this.polling)
  },

};
</script>
<style>
  .wide_dp .v-btn{
    margin: 10px 0!important;
    padding: 15px!important;
  }
  .wide_dp .v-btn .v-btn__content{
    font-size: 1.5rem!important;
    line-height: 2rem!important;
  }
  .wide_dp .v-btn .v-date-picker-table__events{
    margin-bottom: -3px!important;
    color: #42a5f5!important;
    font-weight:900;
  }
  .v-dialog{
  margin:0!important
  }
  .v-pagination__navigation{
    margin: .3rem 3px;
  }
  .v-pagination__item{
    margin: .3rem 3px;
  }
</style>
